import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const ColorCorrectionRecordingComposition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={485}
			style={{
				width: 1620,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/color-correction-source-2026-10-20-1d526d6291c8.mp4"
				durationInFrames={485}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[0, 180, 390, 397],
					['default', 'ew-resize', 'default', 'auto'],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 100, 104, 206, 347, 436, 441],
						[
							4.783618597770655, 4.30525673799359, 4.783618597770655,
							4.30525673799359, 4.783618597770655, 4.30525673799359,
							4.783618597770655,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
							26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
							42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
							58, 59, 60, 61, 62, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75,
							76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91,
							92, 93, 94, 95, 96, 97, 98, 145, 146, 147, 148, 149, 150, 151,
							152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164,
							165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177,
							178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190,
							191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 231, 232, 233,
							234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246,
							247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259,
							260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272,
							273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 294,
							295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 306, 307, 389,
							390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402,
							403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415,
							416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427, 428,
							429, 430, 431, 432, 433, 434,
						],
						[
							'-1562.8418307099384px 2607.5953440691383px',
							'-1539.9327822690525px 2607.5953440691383px',
							'-1389.7906907335555px 2607.5953440691383px',
							'-991.2554663067879px 2556.4704203054644px',
							'-544.622451760248px 2451.342927215395px',
							'-71.67953492596966px 2316.2804458689643px',
							'207.78843284066284px 2229.9323929771745px',
							'516.088914264952px 2130.560191012548px',
							'727.2034569118772px 2075.567263148333px',
							'874.6173909658331px 2013.6231395092325px',
							'974.8304633870988px 1953.472872844296px',
							'1028.6088005917236px 1881.7185938777363px',
							'1066.5600872013806px 1786.4012561151264px',
							'1077.098996924594px 1721.6168589335996px',
							'1093.617429895021px 1648.0687229928758px',
							'1104.8477219936933px 1574.520587052152px',
							'1104.8477219936933px 1500.9724511114282px',
							'1104.8477219936933px 1437.589504690967px',
							'1104.8477219936933px 1368.8063013378664px',
							'1104.8477219936933px 1337.675408432062px',
							'1104.8477219936933px 1312.5053527633233px',
							'1104.8477219936933px 1281.374459857519px',
							'1104.8477219936933px 1250.2435669517147px',
							'1097.036969752021px 1219.1126740459104px',
							'1089.2262175103485px 1187.981781140106px',
							'1072.2593202963808px 1149.4886002361704px',
							'1063.0658033037903px 1103.6331313341032px',
							'1050.6769785759702px 1065.1399504301676px',
							'1041.4834615833797px 1019.2844815281003px',
							'1032.9813269662484px 980.7913006241646px',
							'1028.3845684699531px 934.9358317220974px',
							'1019.8824338528217px 896.4426508181617px',
							'1012.0716816111493px 865.3117579123574px',
							'1000.3742392587882px 834.1808650065531px',
							'993.9462517680339px 814.9716465748802px',
							'984.32295654205px 795.7624281432074px',
							'979.2777338022137px 785.671982663535px',
							'971.7098996924593px 775.5815371838626px',
							'969.1872883225412px 765.49109170419px',
							'964.142065582705px 750.3554234846813px',
							'961.6194542127869px 735.7055915290086px',
							'958.4054604674097px 721.0557595733361px',
							'955.1914667220326px 701.8465411416632px',
							'955.1914667220326px 687.1967091859907px',
							'955.1914667220326px 677.1062637063181px',
							'955.1914667220326px 670.2298119720228px',
							'955.1914667220326px 666.5673539831047px',
							'955.1914667220326px 659.6909022488094px',
							'953.341551717426px 655.9910722395962px',
							'953.341551717426px 649.1146205053008px',
							'953.341551717426px 642.2381687710055px',
							'953.341551717426px 635.3617170367102px',
							'951.5103227229669px 628.4852653024149px',
							'951.5103227229669px 625.1404694860049px',
							'951.5103227229669px 625.1404694860049px',
							'951.5103227229669px 623.8698207959721px',
							'951.5103227229669px 623.8698207959721px',
							'951.5103227229669px 622.5991721059393px',
							'951.5103227229669px 622.5991721059393px',
							'951.5103227229669px 621.2724653854638px',
							'951.5103227229669px 619.758898563513px',
							'951.5103227229669px 619.758898563513px',
							'951.5103227229669px 614.6015597627915px',
							'951.5103227229669px 607.7251080284962px',
							'951.5103227229669px 604.062650039578px',
							'951.5103227229669px 597.1861983052827px',
							'944.9702191713272px 593.1687061235612px',
							'930.3203872156547px 590.6460947536431px',
							'905.1503315469162px 590.6460947536431px',
							'882.2225970958825px 590.6460947536431px',
							'836.3671281938153px 590.6460947536431px',
							'781.7479205325512px 590.6460947536431px',
							'735.8924516304841px 595.2241672397907px',
							'697.3992707265484px 603.6889298366272px',
							'658.9060898226127px 603.6889298366272px',
							'627.7751969168083px 607.5756199473158px',
							'608.5659784851355px 607.5756199473158px',
							'589.3567600534627px 607.5756199473158px',
							'582.4803083191674px 607.5756199473158px',
							'575.6038565848721px 607.5756199473158px',
							'570.4465177841506px 607.5756199473158px',
							'570.4465177841506px 607.5756199473158px',
							'567.4193841402489px 607.5756199473158px',
							'565.5881551457898px 607.5756199473158px',
							'564.074588323839px 606.062053125365px',
							'560.729792507429px 604.548486303414px',
							'560.729792507429px 604.548486303414px',
							'558.8985635129699px 601.2036904870041px',
							'558.8985635129699px 601.2036904870041px',
							'545.7809843893957px 596.8124781023319px',
							'531.1311524337231px 585.3579538818888px',
							'516.4813204780504px 576.4260410313639px',
							'506.3908749983779px 573.9034296614458px',
							'502.72841700945975px 570.2409716725276px',
							'502.72841700945975px 570.2409716725276px',
							'497.5710782087383px 570.2409716725276px',
							'494.2262823923283px 570.2409716725276px',
							'490.5638244034102px 570.2409716725276px',
							'483.68737266911484px 570.2409716725276px',
							'481.85614367465575px 570.2409716725276px',
							'478.1936856857376px 572.0535146568392px',
							'474.5312276968195px 573.8660576411507px',
							'472.6999987023604px 575.3609384529541px',
							'470.8687697079013px 575.3609384529541px',
							'470.8687697079013px 576.8558192647574px',
							'470.8687697079013px 576.8558192647574px',
							'470.8687697079013px 578.1638399750852px',
							'480.4546929135902px 579.6400347767411px',
							'505.5873765620336px 582.8353425119707px',
							'544.0431854456743px 591.3001051088071px',
							'589.8612823274464px 600.4562500811024px',
							'644.4431179684154px 605.7257049427092px',
							'682.8989268520561px 609.6123950533978px',
							'713.9924477375653px 613.4990851640865px',
							'733.164294148943px 616.6943928993161px',
							'743.2173676083204px 616.6943928993161px',
							'746.8424535769435px 616.6943928993161px',
							'750.4675395455665px 616.6943928993161px',
							'754.0926255141896px 616.6943928993161px',
							'757.7177114828128px 616.6943928993161px',
							'767.7707849421901px 619.1983182590867px',
							'782.3832448775677px 619.1983182590867px',
							'796.9957048129452px 621.7022436188572px',
							'816.1675512243229px 621.7022436188572px',
							'835.3393976357006px 621.7022436188572px',
							'849.9518575710781px 624.2061689786278px',
							'864.5643175064557px 624.2061689786278px',
							'874.6173909658331px 624.2061689786278px',
							'878.2424769344561px 624.2061689786278px',
							'881.8675629030793px 624.2061689786278px',
							'885.4926488717023px 624.2061689786278px',
							'886.9875296835056px 624.2061689786278px',
							'890.2949534796205px 624.2061689786278px',
							'893.9200394482436px 624.2061689786278px',
							'897.5451254168667px 624.2061689786278px',
							'901.1702113854898px 624.2061689786278px',
							'904.7952973541128px 624.2061689786278px',
							'908.4203833227359px 624.2061689786278px',
							'909.9152641345393px 624.2061689786278px',
							'911.4101449463426px 624.2061689786278px',
							'911.4101449463426px 624.2061689786278px',
							'912.7742236871131px 624.2061689786278px',
							'914.1383024278837px 624.2061689786278px',
							'914.1383024278837px 622.6926021566769px',
							'914.1383024278837px 622.6926021566769px',
							'914.6988827323099px 622.6926021566769px',
							'914.6988827323099px 622.6926021566769px',
							'924.2848059379987px 622.6926021566769px',
							'928.1714960486873px 622.6926021566769px',
							'931.9460700984907px 622.6926021566769px',
							'933.8333571233925px 622.6926021566769px',
							'939.3831021372124px 622.6926021566769px',
							'939.3831021372124px 622.6926021566769px',
							'948.0347248355241px 622.6926021566769px',
							'954.967234600262px 622.6926021566769px',
							'958.2746583963769px 622.6926021566769px',
							'959.3584469849344px 620.6371410404474px',
							'960.3488055227541px 618.2266457314145px',
							'960.3488055227541px 618.2266457314145px',
							'961.8810583548525px 617.759495477726px',
							'965.038994069787px 617.6100073965456px',
							'966.870223064246px 617.5913213863981px',
							'972.1023059055577px 617.5913213863981px',
							'978.941385619558px 617.5913213863981px',
							'987.6864383686075px 617.5913213863981px',
							'991.049920195165px 617.5913213863981px',
							'998.8793584469848px 617.5913213863981px',
							'1002.747362547526px 617.5913213863981px',
							'1009.3061521093131px 617.5913213863981px',
							'1013.4170743417723px 617.5913213863981px',
							'1017.2290204118707px 617.5913213863981px',
							'1021.0222804718217px 617.5913213863981px',
							'1024.7221104810349px 617.5913213863981px',
							'1026.5346534653465px 617.5913213863981px',
							'1033.000012976396px 617.5913213863981px',
							'1036.6064129348715px 617.5913213863981px',
							'1040.3436149643796px 617.5913213863981px',
							'1044.1181890141831px 617.5913213863981px',
							'1047.8927630639866px 617.5913213863981px',
							'1051.66733711379px 617.5913213863981px',
							'1053.4798800981016px 617.5913213863981px',
							'1057.0675940464296px 617.5913213863981px',
							'1060.7861100657904px 617.5913213863981px',
							'1062.5986530501018px 617.5913213863981px',
							'1064.2430219430855px 617.5913213863981px',
							'1065.5884146737085px 617.5913213863981px',
							'1066.9151213941839px 617.5913213863981px',
							'1068.4100022059872px 617.5913213863981px',
							'1069.9235690279381px 617.5913213863981px',
							'1071.4558218600366px 617.5913213863981px',
							'1072.988074692135px 617.5913213863981px',
							'1074.5016415140858px 617.5913213863981px',
							'1075.9404642954464px 617.5913213863981px',
							'1075.9404642954464px 617.5913213863981px',
							'1077.341915056512px 617.5913213863981px',
							'1082.1815916847254px 617.5913213863981px',
							'1083.6391004762336px 617.5913213863981px',
							'1087.002582302791px 617.5913213863981px',
							'1087.002582302791px 617.5913213863981px',
							'1090.3660641293486px 617.5913213863981px',
							'1090.3660641293486px 617.5913213863981px',
							'1091.9170029715947px 617.5913213863981px',
							'1093.5426858544308px 617.5913213863981px',
							'1095.0188806560866px 617.5913213863981px',
							'1096.51376146789px 617.5913213863981px',
							'1098.0273282898406px 617.5913213863981px',
							'1098.0273282898406px 617.5913213863981px',
							'1099.4661510712015px 617.5913213863981px',
							'1100.7554857713817px 617.5913213863981px',
							'1100.7554857713817px 617.5913213863981px',
							'1102.0448204715622px 617.5913213863981px',
							'1102.0448204715622px 617.5913213863981px',
							'1065.0091483591348px 641.4907283651038px',
							'1024.9089705825104px 681.5722201315806px',
							'954.9111765698194px 757.5121653711898px',
							'732.0805055603856px 999.3091366803783px',
							'579.7147788173312px 1170.659849733335px',
							'336.36686866589673px 1427.1066529981963px',
							'198.94995004087565px 1557.0865395844958px',
							'27.56186496762389px 1718.9260734723537px',
							'-218.12179645225334px 1927.8917249523117px',
							'-362.15356266950414px 2038.0831267923645px',
							'-380.50322463439px 2051.8173442508078px',
							'-569.3066711651505px 2194.7653218795012px',
							'-651.9735800578746px 2252.056628991864px',
							'-734.6404889505989px 2309.3479361042264px',
							'-804.3579928110767px 2345.225075587506px',
							'-882.0917950248497px 2387.0443662977045px',
							'-945.4747414453109px 2418.69846748764px',
							'-1000.0939491065751px 2443.681663054903px',
							'-1045.9494180086422px 2466.5720254856415px',
							'-1084.442598912578px 2483.5015506793143px',
							'-1115.5734918183823px 2495.1616210113802px',
							'-1170.1926994796465px 2510.297289230889px',
							'-1201.3235923854509px 2518.070669452266px',
							'-1239.8167732893864px 2526.5354320491024px',
							'-1278.3099541933223px 2535.000194645939px',
							'-1303.4800098620608px 2535.000194645939px',
							'-1318.1298418177334px 2537.5041200057094px',
							'-1332.779673773406px 2537.5041200057094px',
							'-1351.9888922050789px 2543.8947354761685px',
							'-1371.1981106367516px 2550.285350946628px',
							'-1396.3681663054901px 2557.367348792546px',
							'-1405.9727755213266px 2560.5626565277757px',
							'-1446.4653595110494px 2588.19926553599px',
							'-1471.635415179788px 2602.3632612278266px',
							'-1492.9187807378378px 2620.4139470303517px',
							'-1520.1629835329534px 2639.847397583795px',
							'-1539.3722019646264px 2652.6286285247133px',
							'-1548.9768111804626px 2659.0192439951725px',
							'-1564.1124793999713px 2671.5762428143207px',
							'-1570.9889311342667px 2675.8927111584026px',
							'-1572.8201601287258px 2679.517797127026px',
							'-1574.6513891231848px 2681.330340111337px',
							'-1576.1649559451357px 2683.142883095649px',
							'-1576.1649559451357px 2684.637763907452px',
							'-1576.1649559451357px 2686.1326447192555px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
